import { LinkButton } from "../LinkButton/LinkButton"
import { Fragment } from "react"
import { Box } from "../Box/Box"
import "./AdminSidebar.css"
import { useLoadContext } from "shared/src/libs/contextLib/contextLib"
import { CurrentLink, NavbarLink } from "shared/src/libs/admin/adminLib.types"

export function AdminSidebar({
	navbarLink,
	clientId,
	currentLink,
}: Readonly<{
	navbarLink: NavbarLink
	clientId?: string
	currentLink: CurrentLink
}>) {
	const { user } = useLoadContext()
	return (
		<Box className="admin-sidebar">
			{Object.values(navbarLink)
				.filter((page) => page.allowedUsers == null || page.allowedUsers.includes(user.role as "admin" | "support"))
				.map((page: any) => {
					return (
						<Fragment key={page.path}>
							<LinkButton
								className={`link-button-${page.title}`}
								path={page.path}
								current={currentLink}
								clientId={clientId}>
								{page.title}
							</LinkButton>
						</Fragment>
					)
				})}
		</Box>
	)
}
